/**
 * Represents a SaleSys user
 */
export default class User {
  id: string;
  teamId?: string;
  supervisedTeamIds?: string[];
  organizationId?: string;
  type: UserType;
}

export enum UserType {
  Admin = 'admin',
  Standard = 'standard'
}